import React from "react";
import { Flex, StyledText, Types } from "@emonvia/web-components";
import { useTranslation } from "@/utils/translations/Translator";
import DataTextFrame from "@/components/DataTextFrame";
import { IOnboardingConnector } from "@/api/ApiTypes";
import { useOnboarding } from "@/hooks/useOnboarding";
import ConnectorIcon from "@/assets/images/connector.svg";
import { arraySorter } from "@/utils/helpers";

const ConnectorsSection: React.FC = () => {
  const { t } = useTranslation();
  const { data } = useOnboarding();

  const connectors = data?.chargePoint?.connectors || [];

  const connectorsData = arraySorter(connectors, "connectorIdentifier")?.map(
    (connector: IOnboardingConnector) => {
      return {
        label: (
          <>
            <p style={{ display: "flex", gap: 10 }}>
              {t("EVSE_ID")}
              <StyledText text={connector?.evseId ?? "-"} type={Types.ns_14_m} />
            </p>
            <p style={{ display: "flex", gap: 10 }}>
              {t("PHASE_ROTATION")}
              <StyledText
                text={connector?.emsConnectorInfo?.phaseRotation ?? "-"}
                type={Types.ns_14_m}
              />
            </p>
            <p style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {t("MAX_LOAD")}
              <span style={{ display: "flex" }}>
                <StyledText
                  text={connector?.emsConnectorInfo?.maxLoad ?? "-"}
                  type={Types.ns_14_m}
                />
                <StyledText
                  text={connector?.emsConnectorInfo?.maxLoadUnit ?? ""}
                  type={Types.ns_14_m}
                />
              </span>
            </p>
          </>
        ),
        value: `${t("CONNECTOR")} ${connector?.connectorIdentifier}`,
        icon: ConnectorIcon
      };
    }
  );

  return (
    <Flex flexDirection="column" justifyContent="center" gap={16}>
      <DataTextFrame data={connectorsData} />
    </Flex>
  );
};

export default ConnectorsSection;
